import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject, isNonEmptyString } from '~/shared/utils/guards'

export default class PageSeo extends BaseModel {
  static override constructorName = 'PageSeo'

  id: number = 0
  title: string = ''
  path: string = ''
  seo_title: string = ''
  seo_description: string = ''
  seo_h1: string = ''
  seo_keywords: string = ''
  page_type: string = ''
  image: string = ''
  url: string = ''
  canonical_link: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }

  get isEmpty(): boolean {
    return !isNonEmptyString(this.seo_title) && !isNonEmptyString(this.title)
  }
}

registerModel(PageSeo)
